import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { from, Observable, switchMap, timeout } from 'rxjs';
import { CostReport } from '../../interfaces/cost-report';
import { environment } from '../../../environments/environment';
import { AuthenticationService } from '../authentication/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  private apiUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private authenticationService: AuthenticationService
  ) { }

  getReport(link_base64: string): Observable<CostReport> {
    return from(this.authenticationService.getIdToken()).pipe(
      switchMap(idToken => {
        if (!idToken) {
          throw new Error('ID token is undefined');
        }
        const headers = new HttpHeaders()
          .set('content-type', 'application/json')
          .set('Authorization', idToken);
        return this.http.post<CostReport>(`${this.apiUrl}/real-estates/${link_base64}/report`, {}, { headers }).pipe(
          timeout(180000)
        );
      })
    );
  }
}
